export default __webpack_public_path__ + "static/media/IMG_1994.afd3a9a3.JPG";